/* eslint-disable array-callback-return */
import React, { useEffect, useState, useCallback } from "react";
import DashboardPage from "../../layout";
import { getHorecaCollectionReport } from "../../api/employee";
import { getGlobalFilter } from "../../api/filters";
import PaginationComponent from "../../components/Pagination";
import Loader from "../../components/Loader";
import Export from "../../assets/icons/Export.svg";
import Filter from "../../assets/icons/Filter.svg";
import {
  formatCurrentStartDate,
  formatCurrentEndDate,
  getPagePerSize,
} from "../../utility";
import TimeFrameSelector from "../../components/TimeFrameSelector";
import { formatDate } from "../../utility";
import Dropdown from "../../components/Dropdown";
import DropdownMulti from "../../components/DropdownMultiple";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Close from "../../assets/close-circle.svg";
import Search from "../../assets/Search.svg";
import Eye from "../../assets/eye.svg";
import ImageDailog from "../../components/ImageDailog";
import { formatNumber, TimeZoneDisplay } from "../../utility";
import Button from "../../components/Button";
import debounce from "lodash/debounce";
import { toast, ToastContainer } from "react-toastify";
import { HORECA_POSITIONS } from "../../utility/constant";
import { useDateRangeSelector } from "../../components/DateRangeSelector";

const applyHorecaFields = (data: Record<string, unknown>) => {
  data.positions = HORECA_POSITIONS;
  data.horeca = true;
};

const PAYMENT_TYPE_OPTIONS = [
  { value: "CARD", labelKey: "paymentTypeCard" },
  { value: "BANK_TRANSFER", labelKey: "paymentTypeBankTransfer" },
];

const formatPaymentTypeDisplay = (
  value: string | undefined,
  t: (key: string) => string
) => {
  const normalized = (value || "").toUpperCase();
  if (normalized === "BANK_TRANSFER") {
    return t("horecaCollectionReport.paymentTypeBankTransfer");
  }
  if (normalized === "CASH") {
    return t("horecaCollectionReport.paymentTypeCash");
  }
  if (normalized === "CARD") {
    return t("horecaCollectionReport.paymentTypeCard");
  }
  return value || "-";
};

const HorecaCollectionReport: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [employees, setEmployeesData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [loadingFilter, setLoadingForFilter] = useState(false);
  const [timeFrame, setSelectTimeFrame] = useState<any>("Today");
  const [startDate, setStartDate] = useState<any>(new Date());
  const [endDate, setEndDate] = useState<any>(new Date());
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sortType, setSortType] = useState<any>("");
  const { t } = useTranslation();
  const [globalFilters, setGlobalFilters] = useState<any>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedEmpId, setSelectedEmpId] = useState<any>([]);
  const [selectedEmpStatus, setSelectedEmpStauts] = useState<any>("");
  const [selectedSalesOffice, setSelectedSalesOffice] = useState<any>([]);
  const [selectedRegion, setRegion] = useState<any>([]);
  const [territoryId, setTerritoryId] = useState<any>([]);
  const [routeId, setRouteId] = useState<any>([]);
  const [supervisorId, setSupervisorId] = useState<any>([]);
  const [supervisorList, setSupervisorList] = useState<any[]>([]);
  const [lastFilterSelections, setLastFilterSelections] = useState<{ regions: any[]; sales_office_ids: any[]; channel_ids: any[]; territory_ids: any[] }>({ regions: [], sales_office_ids: [], channel_ids: [], territory_ids: [] });
  const [openSnapshot, setOpenSnapshot] = useState<{ regions: any[]; sales_office_ids: any[]; channel_ids: any[]; territory_ids: any[] }>({ regions: [], sales_office_ids: [], channel_ids: [], territory_ids: [] });
  const [filteredEmployees, setFilteredEmployees] = useState<any[]>([]);
  const [viewImg, setViewImg] = useState<any>(false);
  const [imgUrl, setImgUrl] = useState<any>();
  const [imgType, setImgType] = useState<any>();

  const [userType, setUserType] = useState<any>("");
  const [paymentType, setPaymentType] = useState<any>("");
  const [channelId, setChannelId] = useState<any>([]);
  const [dateMode, setDateMode] = useState<"picker" | "quarter" | "month">("picker");
  const dateRangeSelector = useDateRangeSelector(2024);
  const employeesPerPage = getPagePerSize();

  const getGlobalFilters = async (data: any) => {
    try {
      setLoadingForFilter(true);
      const response = await getGlobalFilter(data);
      setLoadingForFilter(false);
      setGlobalFilters(response);
      const supervisors = response?.employees?.filter((emp: any) => emp.position === "DD Supervisor") || [];
      setSupervisorList(supervisors);
    } catch (error) {
      console.error("Error fetching global filters:", error);
    }
  };

  const handleFilterClick = () => {
    setOpen(true);
  };

  const handleChange = (event: any) => {
    updateSearchTerm(event);
    setSearchQuery(event);
  };

  const updateSearchTerm = useCallback(
    debounce((value: string) => {
      const data: any = {
        start_date: formatCurrentStartDate(new Date(startDate)),
        end_date: formatCurrentEndDate(new Date(endDate)),
      };

      if (value) {
        data["search"] = value;
      }
      getPayload(data);
      const params = {
        page: 1,
        size: employeesPerPage,
      };
      setCurrentPage(1);
      getEmployeesData(data, params);
    }, 500),
    [
      startDate,
      endDate,
      selectedEmpStatus,
      channelId,
      selectedRegion,
      routeId,
      selectedSalesOffice,
      selectedEmpId,
      territoryId,
      userType,
      paymentType,
      sortType,
      employeesPerPage,
    ]
  );

  const handleSortFillter = (data: string) => {
    if (data === sortType) {
      setSortType("");
      handleApply("");
    } else {
      setSortType(data);
      handleApply(data);
    }

    setIsDropdownOpen(false);
  };

  function getCurrentDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleClose = () => setOpen(false);

  const handleClearFilters = () => {
    setSelectedEmpId([]);
    setSelectedSalesOffice([]);
    setRegion([]);
    setTerritoryId([]);
    setRouteId([]);
    setUserType(null);
    setChannelId([]);
    setSelectedEmpStauts(null);
    setSupervisorId([]);
    setPaymentType("");
    dateRangeSelector.reset();
    setDateMode("picker");
    setStartDate(getCurrentDate());
    setEndDate(getCurrentDate());
    setSelectTimeFrame("Today");
    handleClearApply("");
  };

  const handleClearApply = (sort: string) => {
    const data: any = {
      start_date: formatCurrentStartDate(new Date()),
      end_date: formatCurrentEndDate(new Date()),
    };
    applyHorecaFields(data);
    const params = {
      page: 1,
      size: employeesPerPage,
    };
    setCurrentPage(1);
    getEmployeesData(data, params);
    handleClose();
  };

  const handleExport = async () => {
    setLoading(true);
    const data: any = {
      start_date: formatCurrentStartDate(new Date(startDate)),
      end_date: formatCurrentEndDate(new Date(endDate)),
      export: true,
      time_zone: TimeZoneDisplay(),
    };

    if (searchQuery) {
      data["search"] = searchQuery;
    }
    if (sortType) {
      data["sort_by"] = sortType;
    }
    applyHorecaFields(data);
    getPayload(data);
    const params = {};
    try {
      await exportActiviyData(data, params);
    } catch (error) {
      console.error("Error exporting data:", error);
    } finally {
      setLoading(false);
    }
  };

  const exportActiviyData = async (data: any, params: any) => {
    await getHorecaCollectionReport(params, data)
      .then((res) => {
        toast.success(res?.message)
        // const url = window.URL.createObjectURL(new Blob([res]));
        // const a = document.createElement("a");
        // a.href = url;
        // a.download = `team_activity_report.csv`;
        // a.click();
        // a.remove();
        // window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error fetching Employee data:", error);
        toast.warn(error?.response?.data?.detail)
      });
  };

  const getEmployeesData = async (data: any, params: any) => {
    setLoading(true);
    await getHorecaCollectionReport(params, data)
      .then((res) => {
        setEmployeesData(res);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching Employee data:", error);
        setLoading(false);
      });
  };

  // Helper to call global filter API with up-to-date values
  function callGlobalFilterWithDates(start: string, end: string, tf: string) {
    const data: any = {};
    if (selectedRegion.length > 0) data["regions"] = selectedRegion;
    if (selectedSalesOffice.length > 0) data["sales_office_ids"] = selectedSalesOffice;
    if (channelId.length > 0) data["channel_ids"] = channelId;
    if (routeId.length > 0) data["route_ids"] = routeId;
    if (territoryId.length > 0) data["territory_ids"] = territoryId;
    data["endpoint"] = "visit-summary";
    if (start) data["start_date"] = formatCurrentStartDate(new Date(start));
    if (end) data["end_date"] = formatCurrentEndDate(new Date(end));
    applyHorecaFields(data);
    getGlobalFilters(data);
  }

  // Update: handleStartDateChange and handleEndDateChange to call global filter directly
  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDateMode("picker");
    setStartDate(e.target.value);
    checkTimeFrame(e.target.value, endDate);
    callGlobalFilterWithDates(e.target.value, endDate, timeFrame);
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDateMode("picker");
    setEndDate(e.target.value);
    checkTimeFrame(startDate, e.target.value);
    callGlobalFilterWithDates(startDate, e.target.value, timeFrame);
  };

  // Handlers for DateRangeSelector (Year/Quarter and Year/Month)
  const applyYearQuarter = (yearVal: number, quarterVal: string) => {
    if (!yearVal || !quarterVal) return;
    dateRangeSelector.setSelectedMonth(""); // Reset month when quarter is selected
    const { start, end } = dateRangeSelector.getQuarterRange(yearVal, quarterVal);
    const newStartStr = formatDate(start);
    const newEndStr = formatDate(end);
    setStartDate(newStartStr);
    setEndDate(newEndStr);
    setDateMode("quarter");
    callGlobalFilterWithDates(newStartStr, newEndStr, timeFrame);
  };

  const handleYearDropdownChange = (value: string | number) => {
    const yearNum = Number(value);
    dateRangeSelector.setSelectedYear(yearNum);
    if (dateRangeSelector.selectedQuarter) {
      applyYearQuarter(yearNum, dateRangeSelector.selectedQuarter);
    }
  };

  const handleQuarterDropdownChange = (value: string | number) => {
    const quarterStr = String(value);
    dateRangeSelector.setSelectedQuarter(quarterStr);
    if (dateRangeSelector.selectedYear) {
      applyYearQuarter(Number(dateRangeSelector.selectedYear), quarterStr);
    }
  };

  const applyYearMonth = (yearVal: number, monthVal: number) => {
    if (!yearVal || !monthVal) return;
    dateRangeSelector.setSelectedQuarter(""); // Reset quarter when month is selected
    dateRangeSelector.setSelectedYear(""); // Clear quarter year so quarter UI resets
    const { start, end } = dateRangeSelector.getMonthRange(yearVal, monthVal);
    const newStartStr = formatDate(start);
    const newEndStr = formatDate(end);
    setStartDate(newStartStr);
    setEndDate(newEndStr);
    setDateMode("month");
    callGlobalFilterWithDates(newStartStr, newEndStr, timeFrame);
  };

  const handleMonthYearDropdownChange = (value: string | number) => {
    const yearNum = Number(value);
    dateRangeSelector.setSelectedMonthYear(yearNum);
    if (dateRangeSelector.selectedMonth) {
      const monthNum = Number(dateRangeSelector.selectedMonth);
      if (yearNum === dateRangeSelector.currentYear && monthNum > dateRangeSelector.currentMonth) {
        dateRangeSelector.setSelectedMonth("");
      } else {
        applyYearMonth(yearNum, monthNum);
      }
    }
  };

  const handleMonthDropdownChange = (value: string | number) => {
    const monthNum = Number(value);
    dateRangeSelector.setSelectedMonth(String(monthNum));
    if (dateRangeSelector.selectedMonthYear) {
      applyYearMonth(Number(dateRangeSelector.selectedMonthYear), monthNum);
    }
  };

  const handleSetImage = (url: any, type: string) => {
    setImgUrl(url);
    setViewImg(true);
    setImgType(type);
  };

  useEffect(() => {
    const data: any = {
      start_date: formatCurrentStartDate(new Date(startDate)),
      end_date: formatCurrentEndDate(new Date(endDate)),
    };

    if (searchQuery) {
      data["search"] = searchQuery;
    }

    getPayload(data);

    const params = {
      page: currentPage,
      size: employeesPerPage,
    };
    getEmployeesData(data, params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    // Initial load - call global filters with default values
    const data: any = {
      endpoint: "visit-summary",
      start_date: formatCurrentStartDate(new Date(startDate)),
      end_date: formatCurrentEndDate(new Date(endDate)),
    };
    applyHorecaFields(data);
    getGlobalFilters(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const captureOpenSnapshot = (field: 'regions' | 'sales_office_ids' | 'channel_ids' | 'territory_ids') => {
    const normRegion = Array.isArray(selectedRegion) ? selectedRegion : selectedRegion ? [selectedRegion] : [];
    const normSalesOffice = Array.isArray(selectedSalesOffice) ? selectedSalesOffice : [];
    const normChannel = Array.isArray(channelId) ? channelId : [];
    const normTerritory = Array.isArray(territoryId) ? territoryId : [];

    const currentByField: Record<string, any[]> = {
      regions: normRegion,
      sales_office_ids: normSalesOffice,
      channel_ids: normChannel,
      territory_ids: normTerritory,
    };
    const current = currentByField[field] || [];
    setOpenSnapshot((prev) => ({ ...prev, [field]: [...current] }));
  };

  const handleFiltersUpdate = (field: 'regions' | 'sales_office_ids' | 'channel_ids' | 'territory_ids') => {
    // Normalize potentially inconsistent state values (some effects set "" instead of [])
    const normRegion = Array.isArray(selectedRegion) ? selectedRegion : selectedRegion ? [selectedRegion] : [];
    const normSalesOffice = Array.isArray(selectedSalesOffice) ? selectedSalesOffice : [];
    const normChannel = Array.isArray(channelId) ? channelId : [];
    const normTerritory = Array.isArray(territoryId) ? territoryId : [];

    // Current and last values for the specific field
    const currentByField: Record<string, any[]> = {
      regions: normRegion,
      sales_office_ids: normSalesOffice,
      channel_ids: normChannel,
      territory_ids: normTerritory,
    };

    const current = currentByField[field] || [];
    const opened = (openSnapshot as any)[field] || [];

    // a) skip if nothing selected
    if (current.length === 0) {
      return;
    }

    // b) skip if no new selections/unselections compared to when opened
    const changed = JSON.stringify(current) !== JSON.stringify(opened);
    if (!changed) {
      return;
    }

    // Update last selection for this field
    setLastFilterSelections((prev) => ({ ...prev, [field]: [...current] }));

    // Prepare data for global filters with up-to-date selections
    const data: any = {};
    if (normRegion.length > 0) {
      data["regions"] = normRegion;
    }
    if (normSalesOffice.length > 0) {
      data["sales_office_ids"] = normSalesOffice;
    }
    if (normChannel.length > 0) {
      data["channel_ids"] = normChannel;
    }
    if (normTerritory.length > 0) {
      data["territory_ids"] = normTerritory;
    }
    data["endpoint"] = "visit-summary";
    data["start_date"] = formatCurrentStartDate(new Date(startDate));
    data["end_date"] = formatCurrentEndDate(new Date(endDate));
    applyHorecaFields(data);
    getGlobalFilters(data);
  };

  const getPayload = (data: any) => {
    if (selectedEmpStatus) {
      data["status"] = selectedEmpStatus;
    }

    if (channelId.length > 0) {
      data["channel_ids"] = channelId;
    }
    if (selectedRegion.length > 0) {
      data["regions"] = selectedRegion;
    }
    if (routeId.length > 0) {
      data["route_ids"] = routeId;
    }
    if (selectedSalesOffice.length > 0) {
      data["sales_office_ids"] = selectedSalesOffice;
    }
    if (selectedEmpId.length > 0) {
      data["subordinate_ids"] = selectedEmpId;
    }
    if (supervisorId) {
      data["supervisor_ids"] = supervisorId;
    }
    if (territoryId.length > 0) {
      data["territory_ids"] = territoryId;
    }
    if (userType) {
      data["user_type"] = userType;
    }
    if (paymentType) {
      data["payment_type"] = paymentType;
    }
    applyHorecaFields(data);
  };

  const handleApply = (sort: string) => {
    setCurrentPage(1);
    const data: any = {
      start_date: formatCurrentStartDate(new Date(startDate)),
      end_date: formatCurrentEndDate(new Date(endDate)),
    };
    if (searchQuery) {
      data["search"] = searchQuery;
    }
    getPayload(data);
    if (sort) {
      data["sort_by"] = sort;
    }
    applyHorecaFields(data);
    const params = {
      page: 1,
      size: employeesPerPage,
    };

    getEmployeesData(data, params);
    handleClose();
  };

  const checkTimeFrame = (start: any, end: any) => {
    if (start === formatDate(new Date()) && end === formatDate(new Date())) {
      setSelectTimeFrame("Today");
    } else if (
      start === formatDate(new Date().setDate(new Date().getDate() - 1)) &&
      end === formatDate(new Date().setDate(new Date().getDate() - 1))
    ) {
      setSelectTimeFrame("Yesterday");
    } else if (
      start === formatDate(new Date().setDate(1)) &&
      end === formatDate(new Date())
    ) {
      setSelectTimeFrame("Month till date");
    } else {
      setSelectTimeFrame("");
    }
  };

  useEffect(() => {
    setSelectedSalesOffice("");
    setTerritoryId("");
    setRouteId("");
    setSelectedEmpId("");
  }, [selectedRegion]);

  useEffect(() => {
    setTerritoryId("");
    setRouteId("");
    setSelectedEmpId("");
  }, [selectedSalesOffice]);

  useEffect(() => {
    setRouteId("");
    setChannelId("");
    setSelectedEmpId("");
  }, [territoryId]);

  useEffect(() => {
    if (selectedEmpId) {
      globalFilters?.employees?.map((value: any) => {
        if (selectedEmpId === value.id) {
          setUserType(value.position);
        }
      });
    } else {
      setUserType("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEmpId]);

  useEffect(() => {
    // This effect handles both selecting and deselecting a supervisor.
    // Skip the initial mount to avoid duplicate API calls
    if (supervisorId.length === 0 && !globalFilters) {
      return;
    }
    
    setSelectedEmpId([]); // Clear employee selection whenever supervisor changes.

    const data: any = {};
    if (selectedRegion.length > 0) {
        data["regions"] = selectedRegion;
    }
    if (selectedSalesOffice.length > 0) {
        data["sales_office_ids"] = selectedSalesOffice;
    }
    if (channelId.length > 0) {
        data["channel_ids"] = channelId;
    }
    if (routeId.length > 0) {
      data["route_ids"] = routeId;
    }
    if (territoryId.length > 0) {
        data["territory_ids"] = territoryId;
    }
    data["endpoint"] = "visit-summary";
    data["start_date"] = formatCurrentStartDate(new Date(startDate));
    data["end_date"] = formatCurrentEndDate(new Date(endDate));
    
    if (supervisorId && supervisorId.length > 0) {
      // Supervisor is SELECTED. Fetch their employees.
      data["supervisor_ids"] = supervisorId;
      applyHorecaFields(data); // Fetch only employees
      
      // Call API directly, do not update supervisorList
      getGlobalFilter(data).then((response: any) => {
        setGlobalFilters(response);
      });
    } else {
      // Supervisor is DESELECTED. Fetch all employees for current filters.
      applyHorecaFields(data);
      
      // Call the main wrapper function to update everything, including supervisorList.
      getGlobalFilters(data);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supervisorId]);

  useEffect(() => {
    if (globalFilters?.employees) {
      if (supervisorId && supervisorId.length > 0) {
        setFilteredEmployees(
          globalFilters.employees.filter((emp: any) => !supervisorId.includes(String(emp.id)))
        );
      } else {
        setFilteredEmployees(globalFilters.employees);
      }
    } else {
      setFilteredEmployees([]);
    }
  }, [supervisorId, globalFilters]);

  return (
    <DashboardPage>
      <ToastContainer />
      <div className="bg-gray-50  sm:pl-0 pr-4 ">
        {/* Report Title */}
        <div className="bg-white p-4 border-b-2">
          <h1 className="text-l font-bold text-gray-800">
            {t("horecaCollectionReport.title")}
          </h1>
        </div>
        <div className="hidden mb-2 sm:flex flex-col sm:flex-row justify-between items-center bg-white p-2 border-b-2">
          <div className="w-full sm:w-auto mb-4 sm:mb-0 pl-6">
            <PaginationComponent
              totalCount={employees?.total}
              itemsPerPage={employees?.size}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>

          <div className="flex flex-col sm:flex-row items-center w-full sm:w-auto space-y-4 sm:space-y-0 sm:space-x-4">
            <div className="relative w-full sm:w-auto">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                {/* Add your search icon here */}
                <img src={Search} alt="search" />
              </div>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => handleChange(e.target.value)}
                placeholder={t("planogram.searchPlaceholder")}
                className="w-full sm:w-auto pl-10 pr-4 py-2 text-16 border rounded text-gray-600"
                style={{ borderColor: "#e0e0e0" }}
              />
            </div>

            {/* Buttons group for desktop */}
            <div className="hidden sm:flex space-x-4 items-center">
              {/* <button
                onClick={handleSort}
                className="flex items-center px-4 py-2 text-16 text-gray-600 rounded transition-all"
              >
                <img src={Sort} alt="Sort Icon" className="w-4 h-4 mr-2" />
                Sort by
              </button> */}
              {isDropdownOpen && (
                <ul className="absolute z-50 right-30 top-10 w-48 bg-white border border-gray-300 rounded shadow-lg">
                  <li
                    className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${sortType === "ASC" && "bg-lightgrey"
                      }`}
                    onClick={() => handleSortFillter("ASC")}
                  >
                    {t("planogram.ascending")}
                  </li>
                  <li
                    className={`px-4 py-2 hover:bg-gray-100 cursor-pointer  ${sortType === "DESC" && "bg-lightgrey"
                      }`}
                    onClick={() => handleSortFillter("DESC")}
                  >
                    {t("planogram.descending")}
                  </li>
                </ul>
              )}
                            <button
                onClick={handleExport}
                className={`flex items-center gap-2 px-4 py-2 text-13 font-medium border rounded transition-all ${loading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                disabled={loading}
              >
                {loading ? (
                  <span className="flex items-center gap-2">
                    <span className="loader w-4 h-4 border-2 border-t-2 border-gray-300 rounded-full animate-spin"></span>
                    {t("masterList.exporting")}
                  </span>
                ) : (
                  <>
                    {t("masterList.export")}
                    <img
                      src={Export}
                      alt={t("masterList.export")}
                      className="w-4 h-4 "
                    />
                  </>
                )}
              </button>
              <button
                onClick={handleFilterClick}
                className="flex items-center gap-2 px-4 py-2 text-13 font-normal rounded transition-all"
              >
                <img
                  src={Filter}
                  alt={t("planogram.filter")}
                  className="w-4 h-4 mr-2"
                />
                {t("planogram.filter")}
              </button>


            </div>
          </div>
        </div>
        <div className="sm:hidden flex justify-between items-center p-2 border-b-2 bg-white">
          <div className="flex-grow">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder={t("planogram.searchPlaceholder")}
              className="w-full px-4 py-2 text-13 border rounded text-gray-600"
              style={{ borderColor: "#e0e0e0" }}
            />
          </div>

          {/* Hamburger menu for Sort, Filter, Export */}
          <div className="flex items-center space-x-2">
            <button
              onClick={handleExport}
              className={`flex items-center gap-2 px-4 py-2 text-13 font-medium border rounded transition-all ${loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
              disabled={loading}
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <span className="loader w-4 h-4 border-2 border-t-2 border-gray-300 rounded-full animate-spin"></span>
                  {t("masterList.exporting")}
                </span>
              ) : (
                <>
                  {t("masterList.export")}
                  <img
                    src={Export}
                    alt={t("masterList.export")}
                    className="w-4 h-4 "
                  />
                </>
              )}
            </button>

            <button
              className="px-2 py-2 text-gray-600 rounded transition-all"
              onClick={() => setOpen(!open)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        {open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end sm:items-start items-center z-50">
            <div className="relative bg-white shadow-lg w-full max-w-md h-full">
              <div className="absolute z-30 top-[50%] left-[45%]">
                {loadingFilter && <Loader />}
              </div>
              <div className="flex justify-between p-6 border-b-2">
                <div className="text-16 font-bold">
                  {t("visitreports.filters.title")}
                </div>
                <div>
                  <img
                    className="cursor-pointer"
                    onClick={() => setOpen(false)}
                    src={Close}
                    alt=""
                  />
                </div>
              </div>
              <div className="flex flex-col justify-between h-[calc(100vh-100px)] px-12 pt-6 overflow-y-auto scrollbar scrollbar-thin">
                <div className="flex flex-col gap-[30px]">
                  <div className="flex gap-4">
                    <div className="w-1/2">
                      <DropdownMulti
                        label={t("visitreports.filters.region")}
                        options={globalFilters?.regions.map((sales: any) => ({
                          value: sales,
                          label: sales,
                        }))}
                        selectedValues={selectedRegion}
                        onOpen={() => captureOpenSnapshot('regions')}
                        onClose={() => handleFiltersUpdate('regions')}
                        onChange={setRegion}
                        showSelectAll={true}
                        placeholder={t("visitreports.filters.selectRegion")}
                      />
                    </div>
                    <div className="w-1/2">
                      <DropdownMulti
                        label={t("visitreports.filters.salesOffice")}
                        options={
                          globalFilters?.sales_offices.map((sales: any) => ({
                            value: sales.id,
                            label: sales.name,
                          })) || []
                        }
                        selectedValues={selectedSalesOffice}
                        onOpen={() => captureOpenSnapshot('sales_office_ids')}
                        onClose={() => handleFiltersUpdate('sales_office_ids')}
                        onChange={setSelectedSalesOffice}
                        showSelectAll={true}
                        disabled={selectedRegion.length === 0 || loadingFilter}
                        placeholder={t(
                          "visitreports.filters.selectSalesOffice"
                        )}
                      />
                    </div>
                  </div>

                  {/* <div className="flex gap-4"> */}
                    {/* <div className="w-1/2">
                      <DropdownMulti
                        label={t("visitreports.filters.territoryID")}
                        options={
                          globalFilters?.territories?.map((emp: any) => ({
                            value: String(emp.territory_id),
                            label: emp.territory_identifier,
                          })) || []
                        }
                        selectedValues={territoryId}
                        onChange={setTerritoryId}
                        onOpen={() => captureOpenSnapshot('territory_ids')}
                        onClose={() => handleFiltersUpdate('territory_ids')}
                        disabled={selectedRegion.length === 0 || loadingFilter}
                        placeholder={t(
                          "visitreports.filters.selectTerritoryID"
                        )}
                      />
                    </div> */}

                    {/* <div className="w-1/2">
                      <DropdownMulti
                        label={t("visitreports.filters.channelID")}
                        options={
                          globalFilters?.channels?.map((emp: any) => ({
                            value: emp.id,
                            label: emp.name,
                          })) || []
                        }
                        selectedValues={channelId}
                        onOpen={() => captureOpenSnapshot('channel_ids')}
                        onClose={() => handleFiltersUpdate('channel_ids')}
                        onChange={setChannelId}
                        // disabled={selectedRegion.length === 0 || loadingFilter}
                        placeholder={t("visitreports.filters.selectChannelID")}
                      />
                    </div> */}
                  {/* </div> */}
                  {/* <div>
                      <DropdownMulti
                        label={t("visitreports.filters.supervisorID")}
                        options={
                          supervisorList.map((emp: any) => ({
                            value: emp.id,
                            label: emp.name_eng + " (" + emp.id + ")",
                          })) || []
                        }
                        selectedValues={supervisorId}
                        onChange={setSupervisorId}
                        searchable={true}
                        disabled={selectedRegion.length === 0 || loadingFilter}
                        placeholder={t("visitreports.filters.supervisorID")}
                      />
                    </div> */}
                  {/* <div> */}
                    {/* <div className="w-full">
                      <DropdownMulti
                        label={t("visitreports.filters.routeID")}
                        options={
                          globalFilters?.routes?.map((emp: any) => ({
                            value: `${emp.route_id}`,
                            label: emp.route_identifier,
                          })) || []
                        }
                        selectedValues={routeId}
                        // onClose={handleFiltersUpdate}
                        onChange={setRouteId}
                        disabled={selectedRegion.length === 0 || loadingFilter}
                        placeholder={t("visitreports.filters.selectRouteID")}
                      />
                    </div> */}
                  {/* </div> */}
                  <div className="flex gap-4">
                    <div className="w-full">
                      <DropdownMulti
                        label={t("ActivityReport.employeeName")}
                        options={
                          filteredEmployees.map((emp: any) => ({
                            value: emp.id,
                            label: emp.name_eng + " (" + emp.id + ")",
                          })) || []
                        }
                        selectedValues={selectedEmpId}
                        onChange={setSelectedEmpId}
                        disabled={selectedRegion.length === 0 || loadingFilter}
                        placeholder={t("ActivityReport.employeeName")}
                        searchable={true}
                      />
                    </div>
                    {/* <div className="w-1/2">
                      <Dropdown
                        label={t("visitreports.filters.userType")}
                        options={
                          globalFilters?.user_types.map((emp: any) => ({
                            value: emp,
                            label: emp,
                          })) || []
                        }
                        selectedValue={userType}
                        onChange={setUserType}
                        disabled={selectedRegion.length === 0 || loadingFilter}
                        placeholder={t("visitreports.filters.selectUserType")}
                      />
                    </div> */}
                  </div>
                  <div>
                    <Dropdown
                      label={t("horecaCollectionReport.paymentType")}
                      options={PAYMENT_TYPE_OPTIONS.map((option) => ({
                        value: option.value,
                        label: t(`horecaCollectionReport.${option.labelKey}`),
                      }))}
                      selectedValue={paymentType}
                      onChange={setPaymentType}
                      placeholder={t("horecaCollectionReport.selectPaymentType")}
                    />
                  </div>

                  {/* Year/Quarter and Year/Month (DateRangeSelector) */}
                  <div className="date-range-picker space-y-2">
                    <div className="flex gap-4 justify-between w-full">
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">Year</label>
                        <Dropdown
                          label=""
                          options={dateRangeSelector.getQuarterYearOptions()}
                          selectedValue={dateRangeSelector.selectedYear}
                          onChange={handleYearDropdownChange}
                          placeholder="Select Year"
                        />
                      </div>
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">Quarter</label>
                        <Dropdown
                          label=""
                          options={dateRangeSelector.quarterOptions}
                          selectedValue={dateRangeSelector.selectedQuarter}
                          onChange={handleQuarterDropdownChange}
                          placeholder="Select Quarter"
                        />
                      </div>
                    </div>
                    <div className="flex gap-4 justify-between w-full">
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">Year</label>
                        <Dropdown
                          label=""
                          options={dateRangeSelector.getMonthYearOptions()}
                          selectedValue={dateRangeSelector.selectedMonthYear}
                          onChange={handleMonthYearDropdownChange}
                          placeholder="Select Year"
                        />
                      </div>
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">Month</label>
                        <Dropdown
                          label=""
                          options={dateRangeSelector.getAvailableMonths()}
                          selectedValue={dateRangeSelector.selectedMonth ? Number(dateRangeSelector.selectedMonth) : ""}
                          onChange={handleMonthDropdownChange}
                          placeholder="Select Month"
                        />
                      </div>
                    </div>
                    <div className="flex gap-4 justify-between w-full">
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">
                          {t("visitreports.filters.startDate")}:
                        </label>
                        <input
                          type="date"
                          className={`rounded p-2 border-2 border-gray-400 w-full ${dateMode === "quarter" || dateMode === "month" ? "bg-gray-100 text-gray-400 cursor-not-allowed opacity-70" : ""}`}
                          value={startDate}
                          onChange={handleStartDateChange}
                          onKeyDown={(e) => e.preventDefault()}
                          max={new Date(endDate).toISOString().split("T")[0]}
                          min={(() => {
                            const end = new Date(endDate);
                            const minDate = new Date(end);
                            minDate.setDate(end.getDate() - 30);
                            return minDate > new Date(0) ? minDate.toISOString().split("T")[0] : '1970-01-01';
                          })()}
                          disabled={dateMode === "quarter" || dateMode === "month"}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">
                          {t("visitreports.filters.endDate")}:
                        </label>
                        <input
                          type="date"
                          className={`rounded p-2 border-2 border-gray-400 w-full ${dateMode === "quarter" || dateMode === "month" ? "bg-gray-100 text-gray-400 cursor-not-allowed opacity-70" : ""}`}
                          max={new Date().toISOString().split("T")[0]}
                          min={new Date(startDate).toISOString().split("T")[0]}
                          value={endDate}
                          onChange={handleEndDateChange}
                          onKeyDown={(e) => e.preventDefault()}
                          disabled={dateMode === "quarter" || dateMode === "month"}
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <TimeFrameSelector
                      customClass={"w-full border border-gray-300 rounded p-2"}
                      setSelectTimeFrame={(tf) => {
                        setDateMode("picker");
                        let newStart = startDate;
                        let newEnd = endDate;
                        if (tf === "Today") {
                          newStart = formatDate(new Date());
                          newEnd = formatDate(new Date());
                        } else if (tf === "Yesterday") {
                          newStart = formatDate(new Date(new Date().setDate(new Date().getDate() - 1)));
                          newEnd = formatDate(new Date(new Date().setDate(new Date().getDate() - 1)));
                        } else if (tf === "Month till date" || tf === "Month Till Date") {
                          newStart = formatDate(new Date(new Date().setDate(1)));
                          newEnd = formatDate(new Date());
                        }
                        setSelectTimeFrame(tf);
                        setStartDate(newStart);
                        setEndDate(newEnd);
                        callGlobalFilterWithDates(newStart, newEnd, tf);
                      }}
                      timeFrame={timeFrame}
                      setStartDate={setStartDate}
                      setEndDate={setEndDate}
                    />
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-between mt-4">
                  <Button
                    onClick={handleClearFilters}
                    label={t("visitreports.filters.clearFilter")}
                    type="grey"
                  />
                  <Button
                    onClick={() => handleApply(sortType)}
                    label={t("visitreports.filters.applyFilter")}
                    type="purple"
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="h-[calc(100vh-200px)] md:h-[calc(100vh-125px)] overflow-auto page-container p-2 pt-0 scrollbar scrollbar-thin">
                    <table className="min-w-full bg-white border border-black-200 table-auto border-separate border-spacing-0">
            <thead className="bg-gray-200 sticky top-[0px] z-20">
              <tr>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.createdDate")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.createdTime")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.employeeId")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.employeeName")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.supervisorId")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.supervisorName")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.salesOfficeId")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.salesOfficeName")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.collectionId")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.sapExternalId")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.customerId")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.customerName")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.paidAmount")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.paymentMethod")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.paymentReference")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.amountTransferDate")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.bankName")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("horecaCollectionReport.proofOfBankTransfer")}
                </th>
              </tr>
            </thead>
            <tbody>
              {employees?.items?.length > 0 &&
                !loading &&
                employees.items.map((item: any, index: number) => (
                  <tr key={index} className="text-16 hover:bg-gray-50">
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.created_at
                        ? moment(item.created_at).local().format("DD-MM-YYYY")
                        : "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.created_at
                        ? moment(item.created_at).local().format("hh:mm A")
                        : "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.emp_id || "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.emp_name || "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.supervisor_id || "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.supervisor_name || "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.sales_office_id || "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.sales_office_name || "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.collection_id || "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.sap_external_id || "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.customer_id || "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.customer_name || "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.paid_amount != null || item.amount != null
                        ? formatNumber(item.paid_amount ?? item.amount)
                        : "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {formatPaymentTypeDisplay(
                        item.payment_type ?? item.payment_method,
                        t
                      )}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.payment_reference || "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.date_of_transfer || item.date_of_transfer || "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.bank_name || "-"}
                    </td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                      {item.payment_image_path ? (
                        <button
                          onClick={() =>
                            handleSetImage(
                              item.payment_image_path,
                              t("horecaCollectionReport.proofOfBankTransfer")
                            )
                          }
                        >
                          <img src={Eye} alt="proof of bank transfer" />
                        </button>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {employees?.items?.length === 0 && !loading && (
            <>
              <div className="px-4 py-3 border text-center text-black-600 w-full flex items-center justify-center">
                {t("planogram.noresultsfound")}
              </div>
            </>
          )}
          {loading && <Loader />}
        </div>
        <div className="sm:hidden bg-white p-2 border-t-2 mt-auto">
          <PaginationComponent
            totalCount={employees?.total}
            itemsPerPage={employees?.size}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
      {viewImg && (
        <ImageDailog
          imageUrl={imgUrl}
          onClose={() => setViewImg(false)}
          title={imgType}
        />
      )}
    </DashboardPage>
  );
};

export default HorecaCollectionReport;
